export default __webpack_public_path__ + "static/media/character-13.ad225a81.svg";